// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"GeniusFastCheckoutHost_useFade-fadeIn__0j248","useFade-fadeOut":"GeniusFastCheckoutHost_useFade-fadeOut__f3jpj"};